module.exports = __webpack_public_path__ + "static/media/points10_4.b0cbf93b.png";